<div fxLayout="column" fxFlex fusePerfectScrollbar>

    <mat-list class="date" cdkFocusRegionStart>

        <!-- <h3 matSubheader cdkFocusInit>
            <span>{{'NOTIFICACIONES.INFO.HOY' | translate}}</span>
        </h3> -->

        <div class="secondary-text mat-display-1 mb-0 p-16">
            <h2 class="mt-0 mb-0">{{date | date:"fullDate":'':idiomaActual}}</h2>
            <!-- <div class="mb-12">
                {{date | date:'EEEE'}}
            </div> -->
            <!-- <div fxLayout="row" fxLayoutAlign="start start">
                <span> {{date | date:'d'}}</span>
                <span class="mat-subheading-1">th</span>
                <span> {{date | date:'MMMM'}}</span>
            </div> -->
        </div>
    </mat-list>

    <mat-divider cdkFocusRegionEnd></mat-divider>

    <!-- <mat-list>
        <h3 matSubheader>
            <span>Notificaciones</span>
        </h3>

        <mat-list-item *ngFor="let notif of notificaciones">
            <h3 matLine>{{notif.texto}}</h3>
            <p matLine class="secondary-text">{{notif.fechaCreacion}}</p>
        </mat-list-item>
    </mat-list> -->
    <mat-list>
        <h3 matSubheader>
            <span>{{'NOTIFICACIONES.INFO.TITUNOT' | translate}}</span>
        </h3>
    </mat-list>

    <!-- <div class="p-20"> -->

    <!-- <div *ngFor="let notif of notificaciones; index as i; last as last;" style="width:100%;" fxLayout="column" fxLayoutAlign="start stretch"> -->
    <div style="width:100%;" fxLayout="column" fxLayoutAlign="start stretch">
      <ng-container *ngIf="!notifEmpresa">
      <ng-container *ngFor="let notif of notificaciones; index as i; last as last;">
        <div *ngIf="notif.vivo == 1" class="pl-20 m-20 notificacion" fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'nuevo primary':!notif.status, 'leido': notif.status}">
          <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="80">
            <!-- <h3 class="mb-0 mt-10">{{notif.texto | translate | reemplazo : '-ALVPRRO-' : 'empresaxd'}}</h3> -->
            <h3 class="mb-0 mt-10" [innerHTML]="notif.texto | translate | reemplazo : '-ALVPRRO-' : notif.empresa"></h3>
            <p class="secondary-text">{{notif.fechaCreacion | date:"short":'':idiomaActual}}</p>
          </div>
          <div fxLayout="column" fxLayoutAlign="center center" fxFlex="20">
            <!-- <button *ngIf="notif.status" mat-icon-button color="accent" matTooltip="Marcar como leído">
              <mat-icon>notifications_active</mat-icon>
            </button> -->
            <button *ngIf="!notif.status" class="s-40" mat-icon-button style="color:white;" matTooltip="{{'NOTIFICACIONES.INFO.NOTTTIP' | translate}}" (click)="verNotif(notif.id,i,true,1)">
              <mat-icon>notifications_active</mat-icon>
            </button>
          </div>
          <button class="botCloseNot" mat-icon-button color="accent" (click)="verNotif(notif.id,i,notif.status,0)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- <mat-divider *ngIf="!last"></mat-divider> -->
      </ng-container>
      </ng-container>



      <ng-container *ngIf="notifEmpresa">
        <mat-list-item *ngFor="let notif of notificacionesGenerales | slice:0:minMostrar; index as i; last as last;"  >
           <ng-container *ngIf="notif.accionText!=undefined">
             <div class="notificacion pl-20"   fxLayout="row" fxLayoutAlign="start center" [ngClass]="{'nueva': notif.vivo==1, 'vieja': notif.vivo==0}"  >
               <button mat-icon-button *ngIf="notif.vivo==1" mat-list-icon class="mr-10 s-20 cursorp" (click)="cambiarVivo(notif.productoId,notif._id,notif.vivo)">
                 <mat-icon>email</mat-icon>
               </button>
               <button mat-icon-button *ngIf="notif.vivo==0" mat-list-icon class="mr-10 s-20 cursorp" (click)="cambiarVivo(notif.productoId,notif._id,notif.vivo)" >
                 <mat-icon>drafts</mat-icon>
               </button>
               <!-- <mat-icon >email</mat-icon>
                 <mat-icon *ngIf="notif.vivo==0" mat-list-icon class="mr-10 s-20 cursorp" >drafts</mat-icon> -->

                 <div class="mtb-10" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="80">
                   <h4 style="margin:0px;">{{notif.createdAt | date:"short":'':idiomaActual}}</h4>
                   <p style="margin:0px;"> {{'NOTIFICACION_PRODUCT.TIPO_MENSAJE_MOSTRAR.'+notif.accionText | translate}} </p>
                   <p style="margin:0px;"> {{'NOTIFICACION_PRODUCT.ETI_PRODUC'| translate}}{{'NOTIFICACION_PRODUCT.PRODUCTOS_ID.'+notif.tipoProducto | translate}} {{notif.fechaProducto}} </p>
                 </div>
                 <button class="botCloseNot" mat-icon-button color="accent" (click)="cambiarVivoOcultar(notif.productoId,notif._id,2)">
                   <mat-icon>close</mat-icon>
                 </button>

               </div>
               <mat-divider ></mat-divider>
           </ng-container>
        </mat-list-item>
        <!-- <a (click)="mostrarMas()" *ngIf="!mostrarMasNotif">Mostrar más..</a>
        <a (click)="mostrarMenos()" *ngIf="mostrarMasNotif" >Mostrar menos..</a> -->
        <button *ngIf="mostrarBtnHistori" mat-icon-button color="accent" (click)="historialNotif(urlHistoryProduct)">
          {{'NOTIFICACION_PRODUCT.BTN_MOSTRAR_HISTO'| translate}}
          <mat-icon>storage</mat-icon>
        </button>
      </ng-container>
    </div>

    <!-- </div> -->


    <!-- <mat-divider></mat-divider>

    <mat-list>
        <h3 matSubheader>
            <span>Notes</span>
        </h3>

        <mat-list-item *ngFor="let note of notes">
            <h3 matLine>{{note.title}}</h3>
            <p matLine class="secondary-text">{{note.detail}}</p>
        </mat-list-item>
    </mat-list>

    <mat-divider></mat-divider>

    <mat-list>
        <h3 matSubheader>
            <span>Quick Settings</span>
        </h3>

        <mat-list-item>
            <mat-slide-toggle fxFlex class="mat-primary" [(ngModel)]="settings.notify" aria-label="Notifications"
                              labelPosition="before">
                <h3>Notifications</h3>
            </mat-slide-toggle>
        </mat-list-item>

        <mat-list-item>
            <mat-slide-toggle fxFlex class="mat-accent" [(ngModel)]="settings.cloud" aria-label="Cloud"
                              labelPosition="before">
                <h3>Cloud Sync</h3>
            </mat-slide-toggle>
        </mat-list-item>

        <mat-list-item>
            <mat-slide-toggle fxFlex class="mat-warn" [(ngModel)]="settings.retro" aria-label="Retro Thrusters"
                              labelPosition="before">
                <h3>Retro Thrusters</h3>
            </mat-slide-toggle>
        </mat-list-item>
    </mat-list> -->

</div>
